import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useFirebaseAuth from "../common/useFirebaseAuth";

function useLogin(){
    const navigate = useNavigate();
    const {login} = useFirebaseAuth();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [modal, setModal] = useState({
        title:"",
        content:""
    });
    const [inputs, setInputs] = useState({
        id:"",
        pw:""
    })
    const onEnterPressed = (e) => {
        if(e.key === "Enter"){
            onLoginClickHandler();
        }
    }

    const onLoginClickHandler = async() => {
        if(!inputs.id || !inputs.pw){
            return;
        }
        const result = await login(inputs.id, inputs.pw).then(res => {
            if(res.uid){
                return {canLogin:true, description:res.uid}
            }
            else if(res.toString().includes("invalid-credential")){
                return {canLogin:false, description:"아이디 또는 비밀번호가 틀립니다"}
            }else{
                return {canLogin:false, description:"로그인 중 오류가 발생하였습니다"}
            }
        })
        if(result.canLogin){
            sessionStorage.setItem("uid", result.description)
            navigate("/board")
        }else{
            setModal({
                title:"ERROR",
                content:result.description
            })
            setIsOpenModal(true);
        }

    }

    const onChange = (e) => {
        const {name, value} = e.target;
        setInputs({
            ...inputs,
            [name]:value
        })
    }

    const onLoginModalConfirmClickHandler = () => {
        setIsOpenModal(false);
    }

    return{onEnterPressed, onLoginClickHandler, inputs, onChange, isOpenModal, modal, onLoginModalConfirmClickHandler}
}

export default useLogin;